<template>
  <div class="admin__a-tab-content admin__a-tab-content--show">
    <div class="a-container-form ">
      <div class="a-label a-label--w-280">{{$t('form.retend.own-bid.show-the-following-values-to-participant')}}:</div>
    </div>
    <div class="a-container-checkbox-group">
      <div class="a-checkbox">
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="retend.showOptions.ownPrice" :disabled="!canEditRetend" @change="saveForm">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text">
              {{$t('form.retend.own-bid.current-computed-bid-price')}}
          </span>
        </label>
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="retend.showOptions.ownEstimation" :disabled="!canEditRetend" @change="saveForm">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text">
              {{$t('form.retend.own-bid.final-computed-bid-price-based-on-expert-criteria-and-present-price')}}
          </span>
        </label>
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="retend.showOptions.ownRating" :disabled="!canEditRetend" @change="saveForm">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text">
              {{$t('form.retend.own-bid.rating')}}
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import CommonMixins from '../mixins/common'
  import PermissionsMixins from '../mixins/permissions'

  export default {
    props: {
      retend: Object
    },

    mixins: [
      CommonMixins,
      PermissionsMixins
    ]
  }
</script>

<style scoped>

</style>
